import { makeStyles, createStyles } from "@material-ui/core";
import React from "react";
import GreenTick from "../../icon/GreenTick";
import { IVenueData } from "../types";
import { GetStartedComponent } from "./GetStartedComponent";

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            margin: "10px",
            maxWidth: '40rem',
            [theme.breakpoints.down('sm')]: {
                margin: 0,
            }
        },
        container: {
            margin: '0 1rem 0 1rem'
        },
        large: {
            maxWidth: "100%"
        },
        icon: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: "100%",
            marginBottom: "1rem"
        }
    }))


interface ICompletedContainerProps {
    isAvailable: boolean;
    AvailableComponent: JSX.Element;
    setSubscription: (id: string) => void;
    onBack?: () => void;
    venueData?: Partial<IVenueData>;
    isLarge?: boolean;
    getStartedTextKey: string;
}

export function CompletedContainer({
    isAvailable,
    AvailableComponent,
    setSubscription,
    onBack,
    venueData,
    isLarge,
    getStartedTextKey,
}: ICompletedContainerProps) {
    const classes = useStyles();


    return <div className={`${classes.root} ${isLarge && classes.large}`}>
        <div className={classes.icon}>
            <GreenTick />
        </div>
        <div className={classes.container}>
            {isAvailable ? AvailableComponent : <GetStartedComponent
                signupTextKey={getStartedTextKey} venueData={venueData}
                onBack={onBack} setSubscription={setSubscription} />}
        </div>
    </div>
}